import React from "react";
import { Link } from "react-router-dom";

export default function CampusTeamBuildingHeaderSection({ data, onAction }) {
  return (
    <section className="dynamic-header-section" aria-labelledby="dynamic-header-title">
      <div className="container">
        <div className="row align-items-center justify-content-between dynamic-header-row">
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="dynamic-header-content">
              <nav className="main-title dynamic-header-breadcrumbs" aria-label="Breadcrumb">
                <Link to="/">Home</Link>
                <span aria-hidden="true">|</span>
                <span aria-current="page">{data.breadcrumb}</span>
              </nav>
              <h1 id="dynamic-header-title" className="heading">{data.title}</h1>
              <p className="dynamic-header-description">{data.description}</p>
              <div className="btn-wrapper">
                {data.buttonLink ? (
                  <a className="default-btn white-font" href={data.buttonLink}>{data.buttonText}</a>
                ) : (
                  <button type="button" className="default-btn white-font" onClick={onAction}>
                    {data.buttonText}
                  </button>
                )}
                {data.buttonTextSec?.trim() && (
                  data.secondaryLink ? (
                    <a className="programs-hero-secondary-btn" href={data.secondaryLink}>{data.buttonTextSec}</a>
                  ) : (
                    <button type="button" className="programs-hero-secondary-btn" onClick={onAction}>
                      {data.buttonTextSec}
                    </button>
                  )
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <img
              className="img-responsive dynamic-header-image"
              src={data.image}
              alt={data.imageAlt}
              width="664"
              height="704"
              fetchPriority="high"
            />
          </div>
        </div>
      </div>
    </section>
  );
}


